import React from 'react';
import { createRoot } from 'react-dom/client';

import ConfigContextCreator, { BaseConfig } from '@eika-infrastruktur/config-provider';

import { getContainer, getConfig } from './containerUtils';

interface ContainerTagProps<T> {
    config: T;
}

export default <T extends BaseConfig>(
    namespace: string,
    ContainerTag: React.FC<ContainerTagProps<T>>,
    defaultConfig: T = {} as T,
): void => {
    const appContainers = document.querySelectorAll(`[data-react~="${namespace}"]`);

    [].forEach.call(appContainers, (container: HTMLScriptElement) => {
        const config = getConfig<T>(container);

        const reactContainer = getContainer(container, namespace);
        const ConfigContext = ConfigContextCreator(defaultConfig);
        const root = createRoot(reactContainer);
        root.render(
            <ConfigContext state={config}>
                <ContainerTag config={config} />
            </ConfigContext>,
        );
    });
};
